<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>
                        {{ "DeletedCustomFormTitle" | localize }}:
                    </span>
                    <span class="highlight-user">
                        {{ form?.name + "?"}}
                    </span>
                </h4>
            </div>
            <div class="modal-body">
                <span class="sub-title">{{ "DeletedCustomFormSubTitle" | localize }}</span>
            </div>
            <div class="footer">
                <button
                    (click)="close()"
                    class="btn btn-default font-weight-bold"
                    type="button"
                >
                    {{ "Cancel" | localize }}
                </button>
                <button
                    (click)="delete()"
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                    {{ "Delete" | localize }}
                </button>
            </div>
        </div>
    </div>
</div>
